export * from './resizable.module';
export { Resizable } from './resizable.directive'; // tslint:disable-line
export { ResizeHandle } from './resizeHandle.directive'; // tslint:disable-line
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/angular-resizable-element/dist/esm/src/index.js
// module id = ../../../../angular-resizable-element/dist/esm/src/index.js
// module chunks = 3